import { safeParseJSON } from '@/utils/json-parse';

/** 表单 hidden 字段：对象写入前转 JSON 字符串 */
export function toFormJsonString(value: unknown): string | undefined {
  if (value == null) return undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || undefined;
  }
  try {
    return JSON.stringify(value);
  } catch {
    return undefined;
  }
}

/** 表单 hidden 字段：读取并解析（兼容历史对象直存） */
export function parseFormJsonField<T>(raw: unknown): T | undefined {
  if (raw == null || raw === '') return undefined;
  if (typeof raw === 'object') return raw as T;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return undefined;
    return safeParseJSON(trimmed, undefined) as T | undefined;
  }
  return undefined;
}

export function formJsonFieldFormatter(value: unknown): string {
  if (value == null || value === '') return '';
  if (typeof value === 'string') return value;
  try {
    return JSON.stringify(value);
  } catch {
    return '';
  }
}

export function formJsonFieldNormalize(value: unknown): string | undefined {
  return toFormJsonString(value);
}
